export enum InfoModalEnum {
  LOCALIZATION = 1,
  ADOPTED_DATE = 2,
  PASS_AWAY_DATE = 3
}
